import { LinearProgress } from "@material-ui/core";
import { FormOption } from "components/Layout/ConfigForm";
import React, { Fragment } from "react";
import BarcodeDetails from "./TaskItemDetails/BarcodeDetails";
import ChecklistDetails from "./TaskItemDetails/ChecklistDetails";
import DropdownDetails from "./TaskItemDetails/DropdownDetails";
import FormDetails from "./TaskItemDetails/FormDetails";
import SignatureDetails from "./TaskItemDetails/SignatureDetails";
import TakePhotoDetails from "./TaskItemDetails/TakePhotoDetails";
import { TaskItemTypeEnum } from "./TaskItemListAndAdd";

export interface TaskItemDetailsFormProps {
  type: TaskItemTypeEnum;
  handleTaskItemNameChange: (event: any) => void;
  name: string;
  options: FormOption[];
  onOptionAdd: (option: FormOption) => void;
  onOptionRemove: (option: FormOption) => void;
  onOptionEdit: (option: FormOption) => void;
}

function TaskItemDetailsForm({
  type,
  name,
  handleTaskItemNameChange,
  options,
  onOptionAdd,
  onOptionEdit,
  onOptionRemove,
}: TaskItemDetailsFormProps) {
  let returnForm = (
    <Fragment>
      <LinearProgress />
    </Fragment>
  );
  switch (type) {
    case TaskItemTypeEnum.BARCODE:
      returnForm = (
        <BarcodeDetails
          name={name}
          handleTaskItemNameChange={handleTaskItemNameChange}
        />
      );
      break;
    case TaskItemTypeEnum.CHECKLIST:
      returnForm = (
        <ChecklistDetails
          name={name}
          handleTaskItemNameChange={handleTaskItemNameChange}
          options={options}
          onOptionAdd={onOptionAdd}
          onOptionEdit={onOptionEdit}
          onOptionRemove={onOptionRemove}
        />
      );
      break;
    case TaskItemTypeEnum.DROPDOWN:
      returnForm = (
        <DropdownDetails
          name={name}
          handleTaskItemNameChange={handleTaskItemNameChange}
          options={options}
          onOptionAdd={onOptionAdd}
          onOptionEdit={onOptionEdit}
          onOptionRemove={onOptionRemove}
        />
      );
      break;
    case TaskItemTypeEnum.FORM:
      returnForm = (
        <FormDetails
          name={name}
          handleTaskItemNameChange={handleTaskItemNameChange}
        />
      );
      break;
    case TaskItemTypeEnum.SIGNATURE:
      returnForm = (
        <SignatureDetails
          name={name}
          handleTaskItemNameChange={handleTaskItemNameChange}
        />
      );
      break;
    case TaskItemTypeEnum.TAKE_PHOTO:
      returnForm = (
        <TakePhotoDetails
          name={name}
          handleTaskItemNameChange={handleTaskItemNameChange}
        />
      );
      break;
  }
  return returnForm;
}

export default TaskItemDetailsForm;
